module.exports = [
  {
    ru: 'Общая лексика',
    vocabularies: [
      {
        ru: 'да',
        en: 'Yes',
      },
      {
        ru: 'нет',
        en: 'No',
      },
      {
        ru: 'может быть',
        en: 'perhaps',
      },
      {
        ru: 'пожалуйста',
        en: 'please',
      },
      {
        ru: 'спасибо',
        en: 'thank you',
      },
      {
        ru: 'извините',
        en: 'Excuse me',
      },
      {
        ru: 'ясно, ладно',
        en: 'all right',
      },
      {
        ru: 'Я (не) понимаю',
        en: 'I (do not) understand',
      },
      {
        ru: 'Вы говорите по-немецки?',
        en: 'Do you speak German?',
      },
      {
        ru: 'Я не говорю по-немецки',
        en: 'I do not speak German',
      },
      {
        ru: 'Помогите!',
        en: 'Help!',
      },
      {
        ru: 'Немного помедленнее, пожалуйста',
        en: 'A bit slower please',
      },
      {
        ru: 'Будь здоров(а)! Будьте здоровы!',
        en: 'Bless you!',
      },
      {
        ru: 'Твое (Ваше) здоровье!',
        en: 'Cheers!',
      },
      {
        ru: 'где',
        en: 'Where',
      },
      {
        ru: 'когда',
        en: 'When',
      },
      {
        ru: 'кто',
        en: 'Who',
      },
      {
        ru: 'почему',
        en: 'Why',
      },
    ],
  },
  {
    ru: 'Знакомство, как представиться',
    vocabularies: [
      {
        ru: 'имя',
        en: 'Surname',
      },
      {
        ru: 'Как Вас зовут?',
        en: "What's your name?",
      },
      {
        ru: 'Меня зовут...',
        en: 'My name is…',
      },
      {
        ru: 'Я ...',
        en: 'I am…',
      },
      {
        ru: 'Приятно с Вами познакомиться',
        en: "It's nice to meet you",
      },
      {
        ru: 'Мне X лет',
        en: 'I am X years old',
      },
      {
        ru: 'Я из ...',
        en: "I'm from…",
      },
      {
        ru: 'Сколько Вам лет?',
        en: 'How old are they?',
      },
      {
        ru: 'Где Вы работаете?',
        en: 'Where do they work?',
      },
      {
        ru: 'Откуда Вы?',
        en: 'Where are you from?',
      },
      {
        ru: 'Что привело Вас сюда?',
        en: 'What brings you here?',
      },
      {
        ru: 'Как прошла Ваша поездка?',
        en: 'How was your trip?',
      },
      {
        ru: 'Вы хорошо проводите время?',
        en: 'Do you have a good time?',
      },
      {
        ru: 'Что Вы думаете о ...?',
        en: 'What do you think of …?',
      },
      {
        ru: 'Мои друзья зовут меня ...',
        en: 'My friends call me …',
      },
      {
        ru: 'Мы знакомы?',
        en: 'Do we know each other?',
      },
      {
        ru: 'Это (имя)',
        en: 'This is (name)',
      },
      {
        ru: 'Как прошли Ваши выходные?',
        en: 'How was your weekend?',
      },
    ],
  },
  {
    ru: 'Приветствие / Прощание',
    vocabularies: [
      {
        ru: 'Здорого',
        en: 'Hi',
      },
      {
        ru: 'Доброе утро',
        en: 'Good Morning',
      },
      {
        ru: 'Добрый день. Здравствуй(те)',
        en: 'Good day',
      },
      {
        ru: 'Добрый вечер',
        en: 'Good evening',
      },
      {
        ru: 'Спокойной ночи',
        en: 'Good night',
      },
      {
        ru: 'Пока',
        en: 'Bye',
      },
      {
        ru: 'До свидания',
        en: 'Goodbye',
      },
      {
        ru: 'Как у Вас дела?',
        en: 'How are you?',
      },
      {
        ru: 'хорошо',
        en: 'Good',
      },
      {
        ru: 'плохо',
        en: 'Bad',
      },
      {
        ru: 'Привет',
        en: 'Hey, Hello',
      },
      {
        ru: 'Как дела?',
        en: 'How are you?',
      },
      {
        ru: 'Что нового?',
        en: "What's going on?",
      },
      {
        ru: 'Рад(а) Вас видеть.',
        en: 'Nice to see you',
      },
      {
        ru: 'Приятно с Вами познакомиться',
        en: 'Nice to meet you',
      },
      {
        ru: 'Всего хорошего',
        en: 'Take care',
      },
      {
        ru: 'Давно не виделись',
        en: 'Long time no see',
      },
      {
        ru: 'Как обстоят дела?',
        en: "What's up?",
      },
    ],
  },
  {
    ru: 'В поездке',
    vocabularies: [
      {
        ru: 'Я бы хотел(а)...',
        en: 'I would like…',
      },
      {
        ru: 'Где здесь туалет?',
        en: 'Where are the toilets?',
      },
      {
        ru: 'Который час?',
        en: 'What time is it?',
      },
      {
        ru: 'Я ночую у ...',
        en: 'I stay at ...',
      },
      {
        ru: 'Я навещаю семью',
        en: 'I visit family',
      },
      {
        ru: 'Я здесь на X дня (дней)',
        en: 'I am here for X days',
      },
      {
        ru: 'У вас есть карта?',
        en: 'Do you have a card?',
      },
      {
        ru: 'загранпаспорт',
        en: 'passport',
      },
      {
        ru: 'аэропорт',
        en: 'Airport',
      },
      {
        ru: 'порт, гавань',
        en: 'port',
      },
      {
        ru: 'безопасность',
        en: 'safety',
      },
      {
        ru: 'самолёт',
        en: 'plane',
      },
      {
        ru: 'поезд',
        en: 'train',
      },
      {
        ru: 'корабль',
        en: 'ship',
      },
      {
        ru: 'велосипед',
        en: 'bicycle',
      },
      {
        ru: 'мотоцикл',
        en: 'motorcycle',
      },
      {
        ru: 'автобус',
        en: 'bus',
      },
      {
        ru: 'лететь',
        en: 'to fly',
      },
      {
        ru: 'ехать',
        en: 'drive',
      },
      {
        ru: 'ходить под парусом',
        en: 'sailing',
      },
    ],
  },
  {
    ru: 'Описание пути',
    vocabularies: [
      {
        ru: 'слева',
        en: 'Left',
      },
      {
        ru: 'справа',
        en: 'right',
      },
      {
        ru: 'здесь, тут',
        en: 'here',
      },
      {
        ru: 'там',
        en: 'there',
      },
      {
        ru: 'обратно, назад',
        en: 'back',
      },
      {
        ru: 'вверх',
        en: 'high',
      },
      {
        ru: 'вниз',
        en: 'down',
      },
      {
        ru: 'прямо',
        en: 'straight',
      },
      {
        ru: 'населённый пункт, место',
        en: 'place',
      },
      {
        ru: 'Где находится ...?',
        en: 'Where is…?',
      },
      {
        ru: 'Как мне пройти к ...?',
        en: 'How do I get to…?',
      },
      {
        ru: 'Я ищу улицу ... .',
        en: 'Seeking ... street.',
      },
      {
        ru: 'за углом',
        en: 'around the corner',
      },
      {
        ru: 'далеко',
        en: 'far',
      },
      {
        ru: 'недалеко от, близко от',
        en: 'near',
      },
      {
        ru: 'напротив',
        en: 'across from',
      },
      {
        ru: 'Идите за мной',
        en: 'follow me',
      },
      {
        ru: 'рядом с X',
        en: 'next X',
      },
      {
        ru: 'проходить мимо',
        en: 'pass',
      },
      {
        ru: 'между',
        en: 'between',
      },
    ],
  },
  {
    ru: 'Время / даты',
    vocabularies: [
      {
        ru: 'сейчас',
        en: 'now',
      },
      {
        ru: 'сегодня',
        en: 'today',
      },
      {
        ru: 'завтра',
        en: 'morning',
      },
      {
        ru: 'вчера',
        en: 'yesterday',
      },
      {
        ru: 'секунда',
        en: 'second',
      },
      {
        ru: 'минута',
        en: 'minute',
      },
      {
        ru: 'час',
        en: 'hour',
      },
      {
        ru: 'день',
        en: 'Day',
      },
      {
        ru: 'неделя',
        en: 'week',
      },
      {
        ru: 'месяц',
        en: 'month',
      },
      {
        ru: 'год',
        en: 'year',
      },
      {
        ru: 'рано',
        en: 'early',
      },
      {
        ru: 'поздно',
        en: 'late',
      },
      {
        ru: 'понедельник',
        en: 'Monday',
      },
      {
        ru: 'вторник',
        en: 'Tuesday',
      },
      {
        ru: 'среда',
        en: 'Wednesday',
      },
      {
        ru: 'четверг',
        en: 'Thursday',
      },
      {
        ru: 'пятница',
        en: 'Friday',
      },
      {
        ru: 'суббота',
        en: 'Saturday',
      },
      {
        ru: 'воскресенье',
        en: 'Sunday',
      },
      {
        ru: 'весна',
        en: 'spring',
      },
      {
        ru: 'лето',
        en: 'summer',
      },
      {
        ru: 'осень',
        en: 'autumn',
      },
      {
        ru: 'зима',
        en: 'winter',
      },
      {
        ru: 'январь',
        en: 'January',
      },
      {
        ru: 'февраль',
        en: 'February',
      },
      {
        ru: 'март',
        en: 'March',
      },
      {
        ru: 'апрель',
        en: 'April',
      },
      {
        ru: 'май',
        en: 'May',
      },
      {
        ru: 'июнь',
        en: 'June',
      },
      {
        ru: 'июль',
        en: 'July',
      },
      {
        ru: 'август',
        en: 'August',
      },
      {
        ru: 'сентябрь',
        en: 'September',
      },
      {
        ru: 'октябрь',
        en: 'October',
      },
      {
        ru: 'ноябрь',
        en: 'November',
      },
      {
        ru: 'декабрь',
        en: 'December',
      },
      {
        ru: 'время',
        en: 'time of day',
      },
      {
        ru: 'десятилетие',
        en: 'decade',
      },
      {
        ru: 'столетие, век',
        en: 'century',
      },
    ],
  },
  {
    ru: 'Места',
    vocabularies: [
      {
        ru: 'супермаркет',
        en: 'Supermarket',
      },
      {
        ru: 'больница',
        en: 'hospital',
      },
      {
        ru: 'банк',
        en: 'Bank',
      },
      {
        ru: 'гостиница, отель',
        en: 'hotel',
      },
      {
        ru: 'бар',
        en: 'bar',
      },
      {
        ru: 'аптека',
        en: 'pharmacy',
      },
      {
        ru: 'пляж',
        en: 'Beach',
      },
      {
        ru: 'ресторан',
        en: 'restaurant',
      },
      {
        ru: 'булочная',
        en: 'bakery',
      },
      {
        ru: 'автобусная остановка',
        en: 'Bus stop',
      },
      {
        ru: 'церковь',
        en: 'church',
      },
      {
        ru: 'кинотеатр',
        en: 'movie theater',
      },
      {
        ru: 'заправочная станция (заправка)',
        en: 'Gas station',
      },
      {
        ru: 'музей',
        en: 'museum',
      },
      {
        ru: 'полицейский участок',
        en: 'Police station',
      },
      {
        ru: 'школа',
        en: 'school',
      },
      {
        ru: 'площадь',
        en: 'space',
      },
      {
        ru: 'зоопарк',
        en: 'zoo',
      },
    ],
  },
  {
    ru: 'Покупки',
    vocabularies: [
      {
        ru: 'дорого',
        en: 'expensive',
      },
      {
        ru: 'дёшево',
        en: 'cheap',
      },
      {
        ru: 'бесплатно',
        en: 'free',
      },
      {
        ru: 'Сколько это стоит?',
        en: 'How much is it?',
      },
      {
        ru: 'кассир',
        en: 'cashier',
      },
      {
        ru: 'тележка / корзинка для покупок',
        en: 'Trolley / Cart',
      },
      {
        ru: 'сумка',
        en: 'bag',
      },
      {
        ru: 'гарантия',
        en: 'guarantee',
      },
      {
        ru: 'право возврата товара',
        en: 'refund policy',
      },
      {
        ru: 'карта клиента',
        en: 'debit card',
      },
      {
        ru: 'квитанция с НДС',
        en: 'VAT receipt',
      },
      {
        ru: 'скидка',
        en: 'Discount',
      },
      {
        ru: 'ряд',
        en: 'corridor',
      },
      {
        ru: 'полка',
        en: 'shelf',
      },
      {
        ru: 'примерочная кабина',
        en: 'changing room',
      },
      {
        ru: 'поставка',
        en: 'delivery',
      },
      {
        ru: 'сезонная распродажа',
        en: 'Sale',
      },
      {
        ru: 'Извините, Вы здесь работаете?',
        en: 'Excuse me, do you work here?',
      },
    ],
  },
  {
    ru: 'В ресторане',
    vocabularies: [
      {
        ru: 'Столик на X человек(а), пожалуйста.',
        en: 'A table for X people, please.',
      },
      {
        ru: 'Я бы хотел(а) заказать.',
        en: 'I would like to order.',
      },
      {
        ru: 'Дайте меню, пожалуйста.',
        en: 'Can I have the card?',
      },
      {
        ru: 'Счёт, пожалуйста.',
        en: 'The Bill please.',
      },
      {
        ru: 'завтрак',
        en: 'breakfast',
      },
      {
        ru: 'обед',
        en: 'dine',
      },
      {
        ru: 'ужин',
        en: 'dinner',
      },
      {
        ru: 'столовые приборы',
        en: 'cutlery',
      },
      {
        ru: 'салфетка',
        en: 'napkin',
      },
      {
        ru: 'второй завтрак',
        en: 'brunch',
      },
      {
        ru: 'основное блюдо',
        en: 'main course',
      },
      {
        ru: 'десерт',
        en: 'dessert',
      },
      {
        ru: 'чаевые',
        en: 'tip',
      },
      {
        ru: 'гарнир',
        en: 'garnish',
      },
      {
        ru: 'напитки',
        en: 'beverages',
      },
      {
        ru: 'шведский стол',
        en: 'all you can eat',
      },
      {
        ru: 'акция "счастливые часы"',
        en: 'Happy Hour',
      },
      {
        ru: 'закуски',
        en: 'appetizer',
      },
    ],
  },
  {
    ru: 'В гостинице, в отеле',
    vocabularies: [
      {
        ru: 'номер, комната',
        en: 'room',
      },
      {
        ru: 'обслуживание номеров',
        en: 'room service',
      },
      {
        ru: 'ванная комната',
        en: 'bathroom',
      },
      {
        ru: 'кровать',
        en: 'bed',
      },
      {
        ru: 'спальня',
        en: 'bedroom',
      },
      {
        ru: 'этаж',
        en: 'floor',
      },
      {
        ru: 'лифт',
        en: 'elevator',
      },
      {
        ru: 'стойка администратора (ресепшен)',
        en: 'reception',
      },
      {
        ru: 'полотенце',
        en: 'towel',
      },
      {
        ru: 'соседние комнаты',
        en: 'Outbuildings',
      },
      {
        ru: 'багаж',
        en: 'baggage',
      },
      {
        ru: 'посыльный',
        en: 'page',
      },
      {
        ru: 'миникухня',
        en: 'kitchenette',
      },
      {
        ru: 'постельное бельё',
        en: 'bed linen',
      },
      {
        ru: 'камердинер',
        en: 'valet',
      },
      {
        ru: 'лобби',
        en: 'lobby',
      },
      {
        ru: 'аванс',
        en: 'deposit',
      },
      {
        ru: 'заселиться в гостиницу',
        en: 'check in',
      },
      {
        ru: 'выехать из гостиницы',
        en: 'check-Out',
      },
      {
        ru: 'бесплатно',
        en: 'free',
      },
    ],
  },
  {
    ru: 'Числа',
    vocabularies: [
      {
        ru: 'один',
        en: 'one',
      },
      {
        ru: 'два',
        en: 'Two',
      },
      {
        ru: 'три',
        en: 'Three',
      },
      {
        ru: 'четыре',
        en: 'Four',
      },
      {
        ru: 'пять',
        en: 'five',
      },
      {
        ru: 'шесть',
        en: 'six',
      },
      {
        ru: 'семь',
        en: 'seven',
      },
      {
        ru: 'восемь',
        en: 'eight',
      },
      {
        ru: 'девять',
        en: 'nine',
      },
      {
        ru: 'десять',
        en: 'ten',
      },
      {
        ru: 'одиннадцать',
        en: 'Eleven',
      },
      {
        ru: 'двенадцать',
        en: 'Twelve',
      },
      {
        ru: 'тринадцать',
        en: 'Thirteen',
      },
      {
        ru: 'четырнадцать',
        en: 'fourteen',
      },
      {
        ru: 'пятнадцать',
        en: 'Fifteen',
      },
      {
        ru: 'шестнадцать',
        en: 'Sixteen',
      },
      {
        ru: 'семнадцать',
        en: 'Seventeen',
      },
      {
        ru: 'восемнадцать',
        en: 'Eighteen',
      },
      {
        ru: 'девятнадцать',
        en: 'Nineteen',
      },
      {
        ru: 'двадцать',
        en: 'Twenty',
      },
      {
        ru: 'тридцать',
        en: 'Thirty',
      },
      {
        ru: 'сорок',
        en: 'Fourty',
      },
      {
        ru: 'пятьдесят',
        en: 'Fifty',
      },
      {
        ru: 'шестьдесят',
        en: 'sixty',
      },
      {
        ru: 'семьдесят',
        en: 'Siebzieg',
      },
      {
        ru: 'восемьдесят',
        en: 'eighty',
      },
      {
        ru: 'девяносто',
        en: 'Ninety',
      },
      {
        ru: 'сто',
        en: 'Hundred',
      },
      {
        ru: 'двести',
        en: 'two hundred',
      },
      {
        ru: 'тысяча',
        en: 'thousand',
      },
      {
        ru: 'две тысячи',
        en: 'Two thousand',
      },
      {
        ru: 'миллион',
        en: 'million',
      },
      {
        ru: 'миллиард',
        en: 'billion',
      },
      {
        ru: 'первая (первый)',
        en: 'first (r)',
      },
      {
        ru: 'вторая (второй)',
        en: 'second (r)',
      },
      {
        ru: 'третья (третий)',
        en: 'third (r)',
      },
      {
        ru: 'четвёртая (четвёртый)',
        en: 'fourth (r)',
      },
      {
        ru: 'пятая (пятый)',
        en: 'fifth)',
      },
      {
        ru: 'шестая (шестой)',
        en: 'sixth (r)',
      },
      {
        ru: 'седьмая (седьмой)',
        en: 'seventh)',
      },
    ],
  },
  {
    ru: 'Личные местоимения',
    vocabularies: [
      {
        ru: 'я',
        en: 'I',
      },
      {
        ru: 'ты',
        en: 'you',
      },
      {
        ru: 'он',
        en: 'he',
      },
      {
        ru: 'она',
        en: 'they',
      },
      {
        ru: 'оно',
        en: 'it',
      },
      {
        ru: 'мы',
        en: 'we',
      },
      {
        ru: 'вы',
        en: 'her',
      },
      {
        ru: 'они',
        en: 'they',
      },
    ],
  },
  {
    ru: 'Важные слова',
    vocabularies: [
      {
        ru: 'вещь, предмет',
        en: 'thing',
      },
      {
        ru: 'безопасный',
        en: 'for sure',
      },
      {
        ru: 'и',
        en: 'and',
      },
      {
        ru: 'или',
        en: 'or',
      },
      {
        ru: 'потому что',
        en: 'because',
      },
      {
        ru: 'жизнь',
        en: 'Life',
      },
      {
        ru: 'правительство',
        en: 'government',
      },
      {
        ru: 'ребёнок',
        en: 'child',
      },
      {
        ru: 'фирма',
        en: 'company',
      },
      {
        ru: 'группа',
        en: 'group',
      },
      {
        ru: 'возраст',
        en: 'Age',
      },
      {
        ru: 'луна (Himmelskörper, Vollmond), месяц (Neumond)',
        en: 'moon',
      },
      {
        ru: 'солнце',
        en: 'Sun',
      },
      {
        ru: 'машина, ��втомобиль',
        en: 'automobile',
      },
      {
        ru: 'книга',
        en: 'book',
      },
      {
        ru: 'мир',
        en: 'world',
      },
      {
        ru: 'семья',
        en: 'family',
      },
      {
        ru: 'друг',
        en: 'friend',
      },
      {
        ru: 'закон',
        en: 'law',
      },
    ],
  },
  {
    ru: 'Человек / Тело',
    vocabularies: [
      {
        ru: 'мужчина',
        en: 'man',
      },
      {
        ru: 'женщина',
        en: 'woman',
      },
      {
        ru: 'мальчик',
        en: 'Boy',
      },
      {
        ru: 'девочка',
        en: 'girl',
      },
      {
        ru: 'рука',
        en: 'poor',
      },
      {
        ru: 'рука, ладонь',
        en: 'hand',
      },
      {
        ru: 'нога',
        en: 'leg',
      },
      {
        ru: 'нога, ступня',
        en: 'foot',
      },
      {
        ru: 'глаз',
        en: 'eye',
      },
      {
        ru: 'голова',
        en: 'head',
      },
      {
        ru: 'мозг',
        en: 'brain',
      },
      {
        ru: 'нос',
        en: 'nose',
      },
      {
        ru: 'ухо',
        en: 'ear',
      },
      {
        ru: 'волос(ы)',
        en: 'hair',
      },
      {
        ru: 'бровь',
        en: 'eyebrow',
      },
      {
        ru: 'губы',
        en: 'lips',
      },
      {
        ru: 'палец (Pl. пальцы)',
        en: 'finger',
      },
      {
        ru: 'скелет',
        en: 'skeleton',
      },
      {
        ru: 'кость (Pl. кости)',
        en: 'bone',
      },
      {
        ru: 'кожа',
        en: 'skin',
      },
    ],
  },
  {
    ru: 'Важные глаголы',
    vocabularies: [
      {
        ru: 'быть',
        en: 'be',
      },
      {
        ru: 'получать (получить)',
        en: 'to get',
      },
      {
        ru: 'давать (дать)',
        en: 'give',
      },
      {
        ru: 'жить',
        en: 'Life',
      },
      {
        ru: 'делать',
        en: 'do',
      },
      {
        ru: 'идти, ходить',
        en: 'go',
      },
      {
        ru: 'использовать',
        en: 'to use',
      },
      {
        ru: 'есть, кушать',
        en: 'eat',
      },
      {
        ru: 'думать',
        en: 'think',
      },
      {
        ru: 'приходить (прийти)',
        en: 'come',
      },
      {
        ru: 'иметь',
        en: 'to have',
      },
      {
        ru: 'делать',
        en: 'to do',
      },
      {
        ru: 'говорить, сказать',
        en: 'say',
      },
      {
        ru: 'знать',
        en: 'knowledge',
      },
      {
        ru: 'видеть, смотреть',
        en: 'see',
      },
      {
        ru: 'хотеть',
        en: 'want',
      },
      {
        ru: 'находить (найти)',
        en: 'Find',
      },
      {
        ru: 'рассказывать (рассказать)',
        en: 'tell',
      },
      {
        ru: 'спрашивать (спросить)',
        en: 'ask',
      },
      {
        ru: 'пытаться, пробовать',
        en: 'to attempt',
      },
      {
        ru: 'звонить',
        en: 'call',
      },
    ],
  },
  {
    ru: 'Важные прилагательные',
    vocabularies: [
      {
        ru: 'красивый',
        en: 'beautiful',
      },
      {
        ru: 'уродливый, некрасивый',
        en: 'ugly',
      },
      {
        ru: 'высокий',
        en: 'high',
      },
      {
        ru: 'маленький',
        en: 'small',
      },
      {
        ru: 'большой',
        en: 'large',
      },
      {
        ru: 'новый',
        en: 'New',
      },
      {
        ru: 'длинный, долгий',
        en: 'long',
      },
      {
        ru: 'прекрасный, чудесный',
        en: 'Great',
      },
      {
        ru: 'старый',
        en: 'old',
      },
      {
        ru: 'молодой',
        en: 'young',
      },
      {
        ru: 'другой',
        en: 'different',
      },
      {
        ru: 'важный',
        en: 'important',
      },
      {
        ru: 'плохой',
        en: 'bad',
      },
      {
        ru: 'весёлый',
        en: 'funny',
      },
      {
        ru: 'серьёзный',
        en: 'serious',
      },
      {
        ru: 'сильный',
        en: 'strongly',
      },
      {
        ru: 'простой',
        en: 'easy',
      },
      {
        ru: 'сложный, трудный, тяжёлый',
        en: 'heavy',
      },
      {
        ru: 'бедный',
        en: 'poor',
      },
      {
        ru: 'богатый',
        en: 'rich',
      },
    ],
  },
];
